/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandards {
    getFixupPrototypeFunction() { return ComplianceStandards.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandards>): ComplianceStandards {
        let obj = Object.assign(new ComplianceStandards(), model);
        ComplianceStandards.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandards>): ComplianceStandards {
        if (!model) return null;
        return ComplianceStandards.newInstance(<ComplianceStandards> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandards) {
        if (!obj) return;

        models.ComplianceStandards.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandards): boolean {
        Object.setPrototypeOf(obj, ComplianceStandards.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.reference) {
            models.ReferenceResponse.fixupPrototype(this.reference);
        }
    }

    /**
     * ID
     */
    id: string;

    /**
     * is_internal
     */
    is_internal: boolean;

    /**
     * is_deleted
     */
    is_deleted: boolean;

    /**
     * Description for Compliance Standard
     */
    description: string;

    /**
     * Reference
     */
    reference: models.ReferenceResponse;

    /**
     * Name of the Compliance Standard
     */
    compliance_name: string;

    /**
     * Date and Time of Update
     */
    updated_at: string;

    /**
     * Creator of the particular Compliance
     */
    created_by: string;

    /**
     * Version
     */
    version: Array<string>;

    /**
     * Compliance URI
     */
    compliance_uri: string;

    /**
     * Compliance Number
     */
    compliance_number: string;

    /**
     * Valid Service Types
     */
    valid_service_types: Array<string>;

    /**
     * Scope
     */
    scope: string;

    /**
     * Date and Time of Creation
     */
    created_at: string;

    /**
     * Updated By
     */
    updated_by: string;

    /**
     * Logo of standard
     */
    logo: string;

}
